// utils/emailValidation.js — SOURCE UNIQUE de la validation EMAIL (front).
// ────────────────────────────────────────────────────────────────────────────
// M2-L1 — MIROIR EXACT du back (backend/utils/validators.isValidEmail). Mêmes règles, mêmes
// vecteurs partagés (frontend/src/shared/emailTestVectors.json) → front et back ne divergent plus.
//
// On valide la STRUCTURE, pas la plausibilité réelle (domaine existant / boîte joignable), traitée
// plus tard par DNS + email de vérification. Règles :
//   • trim + minuscules ; longueur totale ≤ 254 ; partie locale 1..64 ; un seul @ ; aucun espace ;
//   • pas de points consécutifs ; partie locale sans point en tête/fin ;
//   • domaine : ≥ 1 point ; étiquettes 1..63, sans tiret en tête/fin, caractères [a-z0-9-] ;
//   • TLD alphabétique ≥ 2 (ou punycode « xn-- ») ;
//   • REFUS si toutes les étiquettes avant le TLD sont numériques (00@000.com) ;
//   • REFUS des IP littérales ; REFUS du domaine interne .local depuis une saisie utilisateur ;
//   • 1101@gmail.com reste VALIDE.

/** true si `value` est une adresse email STRUCTURELLEMENT valide (trim appliqué). */
export const isValidEmail = (value) => {
  if (value == null || typeof value !== 'string') return false;
  const s = value.trim().toLowerCase();
  if (s.length === 0 || s.length > 254) return false;
  if (/\s/.test(s)) return false;
  const at = s.indexOf('@');
  if (at === -1 || at !== s.lastIndexOf('@')) return false;
  const local = s.slice(0, at);
  const domain = s.slice(at + 1);

  if (local.length === 0 || local.length > 64) return false;
  if (local.startsWith('.') || local.endsWith('.') || local.includes('..')) return false;
  if (!/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(local)) return false;

  if (domain.length === 0 || domain.startsWith('.') || domain.endsWith('.') || domain.includes('..')) return false;
  if (domain.indexOf('.') === -1) return false;
  if (domain.startsWith('[') || domain.endsWith(']')) return false;

  const labels = domain.split('.');
  if (labels.length < 2) return false;
  for (const label of labels) {
    if (label.length === 0 || label.length > 63) return false;
    if (label.startsWith('-') || label.endsWith('-')) return false;
    if (!/^[a-z0-9-]+$/.test(label)) return false;
  }
  const tld = labels[labels.length - 1];
  if (!(/^[a-z]{2,}$/.test(tld) || tld.startsWith('xn--'))) return false;

  const beforeTld = labels.slice(0, -1);
  if (beforeTld.length > 0 && beforeTld.every((l) => /^[0-9]+$/.test(l))) return false;
  if (labels.every((l) => /^[0-9]+$/.test(l))) return false;

  if (tld === 'local') return false;

  return true;
};

// Rétro-compat : certains fichiers importaient EMAIL_RE. On garde un export, mais la validation
// de référence est isValidEmail (procédurale). EMAIL_RE reste une pré-garde grossière seulement.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
